// extracted by mini-css-extract-plugin
export default {"offersList":"MyOffers_offersList__MjziZ"};